import { devtools } from "zustand/middleware";
import { create } from "zustand/react";
import { Contract, ContractLight } from "@/types";

type State = {
  isOpen: boolean;
  contract: Contract | ContractLight | null;
  contractType: "contractLight" | "contract";
  open: (contract: Contract | ContractLight, contractType: "contract" | "contractLight") => void;
  close: () => void;
};

export const useCreateOrderFromContractStore = create<State>()(
  devtools((set, _) => ({
    isOpen: false,
    contract: null,
    contractType: "contractLight",
    open: (contract: Contract | ContractLight, contractType: "contract" | "contractLight") =>
      set({ isOpen: true, contract: contract, contractType: contractType }),
    close: () => set({ isOpen: false, contract: null }),
  }))
);
